import { fixDoublyEscapedData } from './fixDoublyEscapedData';
// Need to fix data that was escaped twice from officehome side
export const cleanupOldOfficeHomeSideloadData = (key) => {
    if (!localStorage)
        return;
    // key from officehome side ends up having some strange prefix
    if (!localStorage.hasOwnProperty(`${key}_cleaned`)) {
        const oldBadData = JSON.parse(localStorage.getItem(key) || '[]');
        const cleanData = JSON.stringify(fixDoublyEscapedData(oldBadData));
        localStorage.setItem(key, cleanData);
    }
};
//# sourceMappingURL=cleanupOldOfficeHomeSideloadData.js.map